import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

const SwitchComponent = ({ check, labelId, onChange, id, className = '' }) => {

  const handleChange = (e) => {
    e.preventDefault();
    if (onChange) onChange(e.target.checked, id);
  };

  return (
    <>
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id={`flexSwitchCheckChecked-${id}`}
        checked={check ?? false}
        onChange={handleChange}
      />
      <label className={`form-check-label label-regular ${className}`} htmlFor={`flexSwitchCheckChecked-${id}`}>
        <FormattedMessage id={labelId} />
      </label>
    </>
  );
};

export default SwitchComponent;